<template>
  <div class="box">
    <div class="label">
      <slot name="label" />
    </div>
    <div class="content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentBox',
  props: {
    label: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  border-radius: 8px;
  border: 1px solid $cloudy-blue;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  height: 40px;
  padding: 16px;
}

.label {
  @include textSmall;
  color: $bluey-grey;
}

.content {
  position: relative;
  padding: 10px 0 0 20px;
  @include deviceListInput;
  color: $petrol;
}

.box-fill {
  background: rgba(190, 205, 215, 0.2);
}
</style>
